import { CardDisplay } from "@apac/components/checkout";
import type { CreditCard } from "@b2bportal/card-api";
import { useModuleBEM } from "@b2bportal/core-themes";
import { DeleteCardDialog } from "../DeleteCardDialog";
import styles from "./styles.module.scss";

interface CardListItemProps extends CreditCard {
  onDeleteClick: (paymentId: string) => void;
}

export const CardListItem = ({
  id,
  onDeleteClick,
  ...props
}: CardListItemProps) => {
  const [block] = useModuleBEM(styles, "CardListItem");

  return (
    <div className={block}>
      <CardDisplay {...props} />

      <DeleteCardDialog
        bin={props.bin}
        onDeleteClick={() => onDeleteClick(id)}
      />
    </div>
  );
};
